<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table
        [request]="getRequest"
        [cols]="cols"
        [globalConditionalStyle]="globalConditionalStyle"
        [globalVisualTransform]="globalVisualTransform"
        [filtering]="filtering"
        [showExportCsv]="true">

        <ng-template #thStart>
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>
        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <div class="px-3">
                <app-action-buttons
                        [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                        (showRowButtonEvent)="show('info', data.data)"
                        (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)">
                    </app-action-buttons>
                </div>
            </td>
        </ng-template>
        <ng-template #header>
            <div *ngIf="showWarning" class=" d-flex align-content-start" style=" color: red; font-weight: bold;">Debes
                seleccionar todas las opciones del marco para generar la grafica</div>
            <div class="d-flex bg-white rounded">
                <div class="flex-fill d-flex align-items-center m-2">
                    <span class="mr-2">Semana</span>
                    <p-select [options]="weeks" [(ngModel)]="currentWeek" optionLabel="name" 
                            (onChange)="filterValues()" [appendTo]="'body'">
                    </p-select>
                </div>
                <div class="flex-fill d-flex align-items-center m-2">
                    <span class="mr-2">Año</span>
                    <p-select [options]="years" [(ngModel)]="currentYear" optionLabel="name" 
                            (onChange)="filterValues()" [appendTo]="'body'">
                    </p-select>
                </div>
                <div class="flex-fill d-flex align-items-center m-2">
                    <span class="mr-2">Trampas </span>
                    <p-select [options]="trampas" [(ngModel)]="trampaSelected" optionLabel="name" 
                            (onChange)="filterValues()" [appendTo]="'body'">
                    </p-select>
                </div>
                <div class="flex-fill d-flex align-items-center m-2">
                    <span class="mr-2">Plagas </span>
                    <p-multiSelect defaultLabel="Selecciona plaga" [options]="plagasList" 
                                [(ngModel)]="plagaSelected" [filter]="false" optionLabel="name" 
                                [panelStyle]="{minWidth:'5em'}" [appendTo]="'body'">
                    </p-multiSelect>
                </div>
                
                <div class="d-flex align-items-center m-2">
                    <button class="btn btn-info" (click)="show('grafica',model)">
                        <i class="fa fa-bar-chart" aria-hidden="true"></i>&nbsp;Generar grafica
                    </button>
                </div>
            </div>  
        </ng-template>
    </app-common-list-table>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

<p-dialog 
    *ngIf="canShow['grafica']"
    header="Cantidad Plagas " 
    [(visible)]="canShow['grafica']"  
    [responsive]="true" 
    [style]="{width: '70vw', minWidth: '40vw'}"
>
    <img style="display: block; margin: 0 auto;" *ngIf="loadingCharts" src="assets/icon/load.gif" alt="" srcset="">

    <div *ngIf="!loadingCharts">
        <p-chart  type="line" [data]="dataPlagasChart" [options]="basicOptions">
        </p-chart>
    </div>

    <p-footer>
        <button class="btn btn-dark mx-2" (click)="hide('grafica')">Cerrar</button>
    </p-footer>
</p-dialog>